/** 保障分類設定-共用 */

import { commonMixin } from "@/mixins/common";

export default {
    mixins: [commonMixin],   
    data() {
        return {
            //十大保障分類
            bigCategory: [
                { codeCategory: "D", name: "身故給付" },
                { codeCategory: "L", name: "生存給付" },
                { codeCategory: "A", name: "意外醫療" },
                { codeCategory: "H", name: "疾病醫療" },
                { codeCategory: "C", name: "癌症醫療" },
                { codeCategory: "S", name: "手術醫療" },
                { codeCategory: "P", name: "實支實付" },
                { codeCategory: "M", name: "重疾給付" },
                { codeCategory: "I", name: "失能給付" },
                { codeCategory: "T", name: "長照給付" },
              ],
        };
    },
    methods: {
        /**
         * 檢查字串是否有特殊字元,
         * 回傳true表示正常,
         * 回傳fasle表示有特殊字元
         */
        chekTextRegExp(text) {
            let pattern = /[<>!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g;
            if(text.match(pattern) ){
                return false;
            }
            return true;
        }
    },
  };